import * as React from 'react';

import { BreadcrumbStateInfo } from '~src/app/content/breadcrumbs/BreadcrumbStateInfo';
import { AllUserIdentitiesSubspaceStyles } from '~src/authentication/styles/AllUserIdentitiesSubspaceStyles';
import { Messages } from '~src/codegen/Localize';
import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '~src/style/SpaceContainerStyles';

import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';

export interface AllUserIdentitiesSubspaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedUsers: number;

  readonly subspaceHref: string;
}

export interface AllUserIdentitiesSubspaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly updateBreadcrumbs: (breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) => void;
}

type AllUserIdentitiesSubspaceProps = AllUserIdentitiesSubspaceStateProps & AllUserIdentitiesSubspaceDispatchProps;

interface AllUserIdentitiesSubspaceState {
}

export class AllUserIdentitiesSubspace extends React.PureComponent<AllUserIdentitiesSubspaceProps, AllUserIdentitiesSubspaceState> {

  public constructor(props: AllUserIdentitiesSubspaceProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.updateBreadcrumbs([{
      id: this.props.subspaceHref,
      text: Messages.identityMigration(),
      href: this.props.subspaceHref,
      testId: 'all-user-identities-link'
    }]);
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.identityMigrationTitle() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        {this.getSubspaceHeader()}
        <div className={SpaceContainerStyles.SubplaceArea}>
          <ConnectedExplorer
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              // TODO - 1179234 Add the content actions for identity conflicts.
              // toolbarContentSpecificControls: { beginning: this.addUserButtonOrMenu() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.identityMigration_NoConflicts()
            }}
          />
        </div>
      </div>
    );
  }

  private getSubspaceHeader() {
    return <div className={AllUserIdentitiesSubspaceStyles.MastheadArea}>
      {this.renderSectionTitle()}
      {this.renderDescription()}
      {this.renderProgressBar()}
      {this.renderFailureTypeHeader()}
      {this.renderFailureTypeButtons()}
    </div>;
  }

  private renderSectionTitle() {
    return <div className={AllUserIdentitiesSubspaceStyles.SpaceHeaderContent}>
      <div className={AllUserIdentitiesSubspaceStyles.SpaceSubHeaderText}>
        {Messages.identityMigration_SusbpaceHeader()}
      </div>
    </div>;
  }

  private renderDescription() {
    return <div className={AllUserIdentitiesSubspaceStyles.SpaceHeaderContent}>
      {Messages.identityMigration_Description()}
    </div>;
  }

  private renderProgressBar() {
    return <div className={AllUserIdentitiesSubspaceStyles.SpaceHeaderContent}>
      <div style={{ backgroundColor: 'cyan' }}>
        {`Look at me, I'm a progress bar!  XXXXXXXXX------------------`}
      </div>
      {'X percentage complete :)'} {/* TFSID: 1179213 */}
    </div>;
  }

  private renderFailureTypeHeader() {
    return <div className={AllUserIdentitiesSubspaceStyles.SpaceHeaderContent}>
      <div className={AllUserIdentitiesSubspaceStyles.SpaceHeaderText}>
        {Messages.identityMigration_FailureType_SectionHeader()}
      </div>
    </div>;
  }

  private renderFailureTypeButtons() {

    // TFSID: 1179207 - Fetch user count totals for each failure type and remove the placeholders.

    return <div className={AllUserIdentitiesSubspaceStyles.SpaceHeaderContent}>
      <div className={AllUserIdentitiesSubspaceStyles.FailureTypeButtonGroup}>
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_AllFailed(), 29)}
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_Ambiguous(), 22)}
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_NonExistent(), 2)}
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_Duplicate(), 3)}
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_NonLocal(), 2)}
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_Unknown(), 0)}
        {this.renderFailureType(Messages.identityMigration_FailureTypeGroup_Acknowledged(), 132)}
      </div>
    </div>;
  }

  private renderFailureType(label: string, count: number) {
    return <span className={AllUserIdentitiesSubspaceStyles.FailureTypeItem}>
      <div style={AllUserIdentitiesSubspaceStyles.FailureTypeItemLabel}>
        {label}
      </div>
      <div style={AllUserIdentitiesSubspaceStyles.FailureTypeItemCount}>
        {count}
      </div>
    </span>;
  }
}
